export const materialDownload = {
  // Page name
  navTitle: 'Material Download',

  // Title
  sectionTitle: 'Product & Solution Materials',
  sectionDesc: 'Complete introduction to all products and solutions',

  // Table
  colIndex: 'No.',
  colName: 'Material',
  colAction: 'Action',
  preview: 'Preview',
  download: 'Download',
};
